import React from "react";
import { usePrecandidateContext } from "../context/Context";
import CreateContact from "./CreateContact";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ModalCreateContact = () => {
  const {
    modalContactShow,
    setModalContactShow,
    onCloseForm,
    setContactPreCandidate,
    CreateCandidateInteraction,
    precandidateSelected
  } = usePrecandidateContext();

  const { t } = useTranslation();

  function clearObjectContactPreCandidate() {
    setContactPreCandidate({});

    // initialize props default
    setContactPreCandidate((contactPreCandidate) => ({
      ...contactPreCandidate,
      companyId: 1,
      availabilityStatusId: 1,
      createdBy: 1,
      preCandidateId: 0
    }));
  }

  const handleOnClose = () => {
    setModalContactShow(false);
    onCloseForm();
    clearObjectContactPreCandidate();
  };

  return (
    <Modal show={modalContactShow} onHide={handleOnClose} backdrop="static" className="scale-content">
      <Modal.Header>
        <Modal.Title>
          {t("Contact Pre-Candidate")}
          <h6>{precandidateSelected}</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CreateContact />
      </Modal.Body>
      {handleOnClose || CreateCandidateInteraction ? (
        <Modal.Footer>
          {handleOnClose && (
            <button
              onClick={() => {
                handleOnClose();
              }}
              className="app-button btn-second btn-md"
            >
              {t(`Cancel`)}
            </button>
          )}
          <button
            className="app-button btn-prime btn-md"
            onClick={CreateCandidateInteraction}
          >
            {t("Create")}
          </button>
        </Modal.Footer>
      ) : (
        <></>
      )}
    </Modal>
  );
};

export default ModalCreateContact;
